import {connect} from "react-redux";
import {selectException} from "../../redux/selectors/editor";
import { DialogContent, DialogTitle, Typography } from "@mui/material";
import makeStyles from '@mui/styles/makeStyles';
import Dialog from "./Dialog";
import {removeException} from "../../redux/slices/editor";

const useStyles = makeStyles(theme => ({
    data: {
        fontFamily: 'monospace',
        height: 200,
        overflowY: 'scroll'
    },
    stack: {
        fontFamily: 'monospace',
        height: 200,
        overflowY: 'scroll'
    }
}));

type Props = {
    exception: Error
    removeException: () => any
}
function ExceptionDialog({exception, removeException}: Props) {
    const handleClose = () => {
        removeException();
    }
    const classes = useStyles();

    if (! exception) return null;
    return (
        <Dialog onClose={handleClose}>
            <DialogTitle>Exception</DialogTitle>
            <DialogContent>
                <Typography variant='body1'>{exception.message}</Typography>
                <Typography variant='h6'>Stack</Typography>
                <Typography className={classes.stack}>{exception.stack}</Typography>
            </DialogContent>
        </Dialog>
    );
}
const mapStateToProps = (store: never) => ({
    exception: selectException(store)
});

export default connect(mapStateToProps, {
    removeException,
})(ExceptionDialog);
